// src/analysis/herbicidas/herbicidasFetchData.jsx
//
// Herbicidas comparte el contrato de datos de Aplicaciones Aéreas (mismas
// tarjetas y gráficas), pero lee de sus propias colecciones a través de
// `dashboard/herbicidas/completo`. Las unidades (km/h, msnm) vienen en el
// documento y las tarjetas las respetan tal cual.
import { obtenerDatosCompletosHerbicidas } from "../../utils/Constants";
import { ultimoAnalisis } from "../../utils/mapUtils";
import { buildApsDatosAnalisis, initialIndicatorsAps } from "../aps/apsFetchData";

export const HERBICIDAS_MANUAL_ROWS_KEY = 'herbicidas_manual_rows';
export const HERBICIDAS_MANUAL_ID_KEY = 'herbicidas_manual_id';
export const HERBICIDAS_MODE_KEY = 'herbicidas_modo';
export const HERBICIDAS_MATERIAL_KEY = 'herbicidas_material_type';
export const HERBICIDAS_MACHINERY_KEY = 'herbicidas_maquinaria';

export const readHerbicidasManualRows = () => {
    try {
        const raw = localStorage.getItem(HERBICIDAS_MANUAL_ROWS_KEY) || '[]';
        const rows = JSON.parse(raw);
        return Array.isArray(rows) ? rows : [];
    } catch {
        return [];
    }
};

export const fetchDataHerbicidas = async (idAnalisisHerbicidas, setDatosAnalisis) => {
    try {
        const data = await obtenerDatosCompletosHerbicidas(idAnalisisHerbicidas);
        console.log("ESTOS SON DATOS BACKEND HERBICIDAS:", data);
        setDatosAnalisis(buildApsDatosAnalisis(data));
    } catch (error) {
        console.error("Error al cargar datos de Herbicidas:", error);
        setDatosAnalisis({});
    }
};

// El botón Analizar se habilita con datos manuales guardados (como en APS).
export const shouldEnableExecBashHerbicidas = () => readHerbicidasManualRows().length > 0;

export const cargaDatosHerbicidas = async (userData, selectedAnalysisTypeRef) => {
    if (selectedAnalysisTypeRef.current && userData.userId) {
        try {
            const response = await ultimoAnalisis(selectedAnalysisTypeRef, userData.userId);
            if (response && response.data && response.data.ID_ANALISIS) {
                return response;
            }
            console.error("Respuesta del último análisis no contiene datos esperados");
        } catch (error) {
            console.error("Error al obtener último análisis:", error);
        }
    }
    return undefined;
};

export const initialIndicatorsHerbicidas = initialIndicatorsAps;
